/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from 'axios';
import store from '@/store/';
import router from '@/router';
import {
  getToken
} from '@/utils/auth';
import {
  Message
} from 'element-ui';
import website from "@/utils/website";
import {
  Base64
} from 'js-base64';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
const qs = require('qs');

console.log(process.env)
if (process.env.NODE_ENV != "development") {
  website.host.url = website.host.API_URL;
} else {
  website.host.url = ''
}
const instance = axios.create({
  baseURL: website.host.url,
  paramsSerializer: function(params) {
    return qs.stringify(params, {
      arrayFormat: 'brackets'
    })
  }
})
//默认超时时间
instance.defaults.timeout = 600000
//返回其他状态码
instance.defaults.validateStatus = function(status) {
  return status >= 200 && status <= 500
}
//跨域请求，允许保存cookie
instance.defaults.withCredentials = false
instance.defaults.crossDomain = true
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
instance.defaults.headers.delete['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// NProgress 配置
NProgress.configure({
  showSpinner: false
})
//http request拦截
instance.interceptors.request.use(config => {
  //开启 progress bar
  NProgress.start();
  const meta = (config.meta || {});
  const isToken = meta.isToken === false;
  document.title = website.title;
  config.headers['Authorization'] = `Basic ${Base64.encode(`${website.clientId}:${website.clientSecret}`)}`;
  // config.headers['userId'] = -1
  //让每个请求携带token
  if (getToken() && !isToken) {
    let url = config.url;
    let urlHead = url.substring(1, 8);
    //过滤不用token的接口
    config.headers['Authorization'] = getToken()
  }
  //headers中配置text请求
  if (config.text === true) {
    config.headers["Content-Type"] = "application/x-www-form-urlencoded";
  }
  //headers中配置serialize为true开启序列化
  if (config.method === 'post' && meta.isSerialize === true) {
    config.data = serialize(config.data)
  }
  // if(Object.prototype.toString.call(config.data)!=='[object FormData]' && config.method==='post'){
  //   config.data = qs.stringify(config.data)
  // }
  config.headers['Accept-Language'] = 'zh-CN';
  return config
}, error => {
  return Promise.reject(error)
})
//http response 拦截
instance.interceptors.response.use(res => {
  //关闭 progress bar
  NProgress.done()
  //获取状态码
  const status = res.data.code || res.status
  const statusWhiteList = []
  const message = res.data.msg || res.data.error_description || '未知错误'
  //如果在白名单里则自行catch逻辑处理
  if (statusWhiteList.includes(status)) return Promise.reject(res)
  //如果是401则跳转到登录页面
  if (status === 401) {
    router.push({
      path: '/401'
    });
    //store.dispatch('FedLogOut').then(() => router.push({ path: '/login' }))
  } else if (status == 500) { // 如果请求为非200否者默认统一处理
    if (!getToken()) {
      router.push({
        path: '/login'
      });
      return false;
    }
    Message({
      showClose: true,
      message: '系统异常,请您稍后再试',
      type: 'error'
    })
    return Promise.reject(new Error(message))

  } else if (status === 400) {
    Message({
      showClose: true,
      message: message,
      type: 'warning'
    })
    return Promise.reject(new Error(message))
  } else if (status !== 200 && status !== 401) {
    let msg = '系统维护中，请联系管理员！';
    if (res.data.msg) {
      msg = res.data.msg;
    }
    Message({
      showClose: true,
      message: msg,
      type: 'error'
    })
    return Promise.reject(new Error(message))
  } else if (status === 200 && res.data.errors) {
    if (res.data.status == 'circuit breaker') {
      let msg = '接口访问超时，请刷新页面！';
      Message({
        showClose: true,
        message: msg,
        type: 'error'
      })
      return Promise.reject(new Error(message))
    }
    if (res.data.status == 'traffic control') {
      let msg = '访问频繁，请稍后重试！';
      Message({
        showClose: true,
        message: msg,
        type: 'error'
      })
      return Promise.reject(new Error(message))
    }
  }
  return res
}, error => {
  NProgress.done()
  return Promise.reject(new Error(error))
})

export default instance



// WEBPACK FOOTER //
// ./src/router/axios.js